import { createTag } from '../../../../../utils/googleTagManagerUtils';

export const addAddressSuccessCreateTag = ({ selectMesaType, eventConfigName }) => {
  createTag({
    event: 'mesa_regalos',
    phase: 'Crear mesa de regalos',
    step: 'Agregar direccion exitoso',
    selection: `${selectMesaType}|${eventConfigName}`,
    seccion: 'Mesa de Regalos',
  });
};

// selection: `${this.props.createEventObject.SelectMesaType}|${this.props.createEventObject.SelectTypeCelebration.selectedEventConfiguration.name}`,

export const addAddressFailedCreateTag = ({ errorMessage }) => {
  createTag({
    event: 'alerta',
    phase: 'Crear mesa de regalos',
    step: 'Direccion del evento',
    sub_phase: 'Agregar direccion',
    color: 'Rojo',
    mensaje: 'Campos incompletos',
    mensaje_servicio: errorMessage,
    seccion: 'Mesa de Regalos',
    tipo: 'formulario',
  });
};

// response.body.status.errorMessage,

export const getAddressFailedCreateTag = ({ errorMessage }) => {
  createTag({
    event: 'alerta',
    phase: 'Crear mesa de regalos',
    step: 'Direccion del evento',
    sub_phase: 'Agregar direccion',
    color: 'Rojo',
    mensaje: 'Codigo postal incorrecto',
    mensaje_servicio: errorMessage,
    seccion: 'Mesa de Regalos',
    tipo: 'formulario',
  });
};

// res.status.errorMessage,
